/** Bug#743 @Author: Linda Susan Raju @Date: 03 Feb 2022*/

import { faArrowLeft, FontAwesomeIcon, Row, Wrapper, Text, Col } from "components";
import { size } from "lodash";
import style from './style/backArrowHeader.module.scss';

const BackArrowHeader = ({ onBackClick, headerIcon, headerIconColor, headerTitle, ...props }) => {
    const Icon = headerIcon;
    return (
        <Col>
        <Row className={`${style.backArrowHeaderWidgetContainer}`}>
            <Wrapper className={`${style.backArrowHeaderBackArrow}`} onClick={onBackClick}>
                <FontAwesomeIcon icon={faArrowLeft} style={{fontSize:'16px'}} /> 
             
            </Wrapper>
            <Wrapper className={`${style.backArrowHeaderWidget} text-sm`} style={{ borderColor: headerIconColor }}>
                {Icon && <Icon iconColor={headerIconColor} />}
            </Wrapper>
            <Wrapper className={`${style.backArrowHeaderTitleContainer}`}>
                <Text className={`${style.backArrowHeaderTitle}`}>{headerTitle}</Text>
            </Wrapper>
        </Row>
        </Col>
    );
}
export default BackArrowHeader;